import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { CarouselWrapper, MenuWrapper, Menu, LeftArrow, RightArrow, ArrowsContainer } from './styles';
// import {} from './utils';
import { ReactComponent as ArrowCarousel } from '../../assets/svg/arrow.svg';
import IconContainer from '../IconContainer';
import { useWindowScrollPositions } from '../../hooks/useScrollingPosition';

export interface ICarousel {
  scrollX?: number;
  reference: any;
  marginLeftArrow?: number;
  marginRighttArrow?: number;
}

export interface IArrow {
  margin?: number;
  visible?: boolean;
}

const Carousel: React.FC<ICarousel> = ({ children, reference, marginLeftArrow = 0, marginRighttArrow = 0 }) => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  const { scrollEnd, scrollStart } = useWindowScrollPositions(ref);

  useLayoutEffect(() => {
    setWidth(ref.current?.firstChild?.firstChild?.offsetWidth);
  }, []);

  const handleClickLeft = () => {
    reference.current?.scrollTo({ left: 0, behavior: 'smooth' });
  };

  const handleClickRight = () => {
    reference.current?.scrollTo({ left: width, behavior: 'smooth' });
  };

  return (
    <CarouselWrapper data-testid="carousel" ref={ref}>
      {children}
      <ArrowsContainer>
        <LeftArrow visible={!scrollStart} margin={marginLeftArrow} onClick={handleClickLeft}>
          <IconContainer
            Icon={ArrowCarousel}
            style={{ maxWidth: 12, height: 20, transform: `rotate(180deg)` }}
            disabled
          />
        </LeftArrow>
        <RightArrow visible={!scrollEnd} margin={marginRighttArrow} onClick={handleClickRight}>
          <IconContainer Icon={ArrowCarousel} style={{ maxWidth: 12, height: 20 }} disabled />
        </RightArrow>
      </ArrowsContainer>
    </CarouselWrapper>
  );
};

export default Carousel;
